import React from 'react';

import { BaseFieldConfig } from '@api';
import { Form } from '@ui-library/form';
import { RedAsterisk } from '@components/common/redAsterisk';

interface BaseTextFieldProps {
  fieldConfig: BaseFieldConfig;
  children: React.ReactNode;
}

export const BaseTextField: React.FC<BaseTextFieldProps> = ({ fieldConfig, children }) => (
  <Form.Item
    name={fieldConfig.key}
    label={[fieldConfig.label, fieldConfig.optional ? '' : <RedAsterisk />]}
    extra={fieldConfig.info}
    rules={[{ required: !fieldConfig.optional }, ...(fieldConfig.rules ?? [])]}
    initialValue={fieldConfig.default}
  >
    {children}
  </Form.Item>
);
